import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__en-GB.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    ...sharedConfig['en-GB'].seo,
    title: 'Lemonade UK: Legal',
    metaTitle: 'Lemonade UK: Legal',
    description:
      'Access important legal documents and compliance information for Lemonade UK, including privacy policies and consumer protections for Home insurance.',
  },
  MDXContent: content as DocumentTypes,
};
